var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpecialWordCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 52,
    viewBox: "0 0 79 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.5539 16.4943C78.0159 21.9507 75.7318 28.211 70.1237 34.011C64.5479 39.7776 55.9221 44.7987 45.5427 47.5798C35.1633 50.361 25.1826 50.3255 17.4705 48.1194C9.71381 45.9005 4.60555 41.621 3.14351 36.1646C1.68147 30.7082 3.9656 24.4479 9.57368 18.6479C15.1495 12.8813 23.7753 7.86024 34.1547 5.07909C44.5341 2.29794 54.5147 2.33339 62.2268 4.53952C69.9836 6.75842 75.0918 11.0379 76.5539 16.4943Z",
    stroke: "#B4D400",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialWordCircle);
export default __webpack_public_path__ + "static/media/special-word-circle.3c5475a62b737fa485523f2b1eecc79d.svg";
export { ForwardRef as ReactComponent };